module.exports = __webpack_public_path__ + "media/images/stock/workers-at-desk-8f02780d05b4c3cc36771a083a43fcee.jpg";